import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  flatlistContainer: {
    paddingLeft: 10,
    marginTop: 50,
  },
  dummyBottomContainer: {
    width: '100%',
    bottom: 10,
    height: 120,
  },
  noVenues: {
    color: '#FFF',
    fontSize: 20,
    marginTop: 20,
    padding: 60,
  },
});
